export default "__VITE_PUBLIC_ASSET__839ec0cd__"